import { render, staticRenderFns } from "./ManageWhatsappNotificationsSettingsView.vue?vue&type=template&id=35a9906c"
import script from "./ManageWhatsappNotificationsSettingsView.vue?vue&type=script&lang=ts"
export * from "./ManageWhatsappNotificationsSettingsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports